<template>
    <footer class="footer footer--4">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="footer__top">
                        <logo></logo>
                        <slogan></slogan>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-6">
                    <footer-nav></footer-nav>
                </div>
                <div class="col-lg-6">
                    <contacts></contacts>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-6">
                    <paysistems></paysistems>
                </div>
                <div class="col-lg-6">
                    <copyright></copyright>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
import Logo from "./parts/Logo.vue";
import Slogan from "./parts/Slogan.vue";
import FooterNav from "./parts/FooterNav.vue";
import Contacts from "./parts/Contacts.vue";
import Paysistems from "./parts/Paysistems.vue";
import Copyright from "./parts/Copyright.vue";

export default {
    components: {
        Logo,
        Slogan,
        FooterNav,
        Contacts,
        Paysistems,
        Copyright,
    },
};
</script>

<style lang="scss">
.footer--4 {
    &.footer {
        padding: 80px 0;
        background-color: $brandy;
        .footer__top {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 40px;
        }
        .footer__logo {
            img {
                width: 60px;
                height: auto;
            }
        }
        .footer__slogan {
            width: calc(50% - 12px);
            position: relative;
            display: flex;
            justify-content: space-between;
            align-items: center;
            h4 {
                font-family: $extra-font;
                @include font(24, 700);
            }
            span {
                width: calc(100% - 420px);
                height: 2px;
                background: $marshland;
            }
        }
        .footer__menu {
            display: flex;
            flex-direction: column;
            gap: 40px;
            margin-bottom: 80px;
            li {
                a {
                    font-family: $extra-font;
                    @include font(24, 700);
                }
            }
        }
        .footer__contacts {
            display: flex;
            flex-direction: column;
            height: calc(100% - 80px);
            margin-bottom: 80px;
            &-item {
                @include font(16, 600);
            }
        }
        .footer__paysistems {
            display: flex;
            gap: 12px;
        }
        @media (max-width: $breakpoint-lg) {
            padding: 40px 0 20px 0;
            .footer__logo {
                img {
                    width: 44px;
                }
            }
            .footer__slogan {
                width: calc(100% - 68px);
                justify-content: flex-start;
                gap: 24px;
                h4 {
                    font-size: 12px;
                }
                span {
                    width: 80px;
                }
            }
            .footer__menu {
                gap: 20px;
                margin-bottom: 40px;
                li {
                    a {
                        font-size: 20px;
                    }
                }
            }
            .footer__contacts {
                height: auto;
                margin-bottom: 40px;
                &-item {
                    font-size: 14px;
                    &:first-child {
                        margin-bottom: 20px;
                    }
                }
            }
            .footer__paysistems {
                margin-bottom: 20px;
            }
        }
    }
}
</style>